import { NabcNeume } from './NabcNeume';

export class NabcSnippet {
  private _neumes: NabcNeume[];
  private _mode: 'gall'| 'laon';

  get neumes() {
    return this._neumes;
  }

  get mode() {
    return this._mode;
  }

  constructor(
    neumes: NabcNeume[],
    mode: 'gall'| 'laon',
  ) {
    this._neumes = neumes;
    this._mode = mode;
  }
}
